__turbopack_context__.v({
  "chipDraggable": "ReviewDialog-module__uNm2IW__chipDraggable",
  "columns1": "ReviewDialog-module__uNm2IW__columns1",
  "columns2": "ReviewDialog-module__uNm2IW__columns2",
  "columns3": "ReviewDialog-module__uNm2IW__columns3",
  "columns4": "ReviewDialog-module__uNm2IW__columns4",
  "docSelected": "ReviewDialog-module__uNm2IW__docSelected",
  "documentWithoutPages": "ReviewDialog-module__uNm2IW__documentWithoutPages",
  "doneHeader": "ReviewDialog-module__uNm2IW__doneHeader",
  "double": "ReviewDialog-module__uNm2IW__double",
  "droppableZone": "ReviewDialog-module__uNm2IW__droppableZone",
  "droppableZoneActive": "ReviewDialog-module__uNm2IW__droppableZoneActive",
  "flexInPanelRight": "ReviewDialog-module__uNm2IW__flexInPanelRight",
  "groupHeaderActive": "ReviewDialog-module__uNm2IW__groupHeaderActive",
  "groupHeaderClickable": "ReviewDialog-module__uNm2IW__groupHeaderClickable",
  "loadingWrap": "ReviewDialog-module__uNm2IW__loadingWrap",
  "mainFlex": "ReviewDialog-module__uNm2IW__mainFlex",
  "pageGrid": "ReviewDialog-module__uNm2IW__pageGrid",
  "pageItem": "ReviewDialog-module__uNm2IW__pageItem",
  "panelCenter": "ReviewDialog-module__uNm2IW__panelCenter",
  "panelRight": "ReviewDialog-module__uNm2IW__panelRight",
  "rightStickyHeader": "ReviewDialog-module__uNm2IW__rightStickyHeader",
  "scrollableDocumentsSection": "ReviewDialog-module__uNm2IW__scrollableDocumentsSection",
  "single": "ReviewDialog-module__uNm2IW__single",
  "topHeaderWrap": "ReviewDialog-module__uNm2IW__topHeaderWrap",
  "viewToggle": "ReviewDialog-module__uNm2IW__viewToggle",
});
